export function makeVoid(): void {
  // do nothing
}

export function chatToken(): string {
  return process.env.VUE_APP_CHAT_TOKEN;
}
